var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { S_REVIEW_LIST_REQUEST } from "../../../reducers/shoppingReview";
import { useDispatch, useSelector } from "react-redux";
import ScoreBox from "./score_box";
import Loading2 from "../../main/loading2";
import Item from "./item";
import PageCompoenent from "./page";
import TopFiler from "./top_filter";
import GalleryComponent from "./galleryComponent";
var ShoppingBoard = function (_a) {
    var _b, _c;
    var reviewInfo = _a.reviewInfo, item_id = _a.item_id;
    var dispatch = useDispatch();
    var userInfoLoaded = useSelector(function (state) { return state.common.userInfoLoaded; });
    var viewLoaded = useSelector(function (state) { return state.shoppingReview.viewLoaded; });
    var userInfo = useSelector(function (state) { return state.common.userInfo; });
    var idx_b_manager = userInfo === null || userInfo === void 0 ? void 0 : userInfo.user_idx;
    var reviewFilter = useSelector(function (state) { return state.shoppingReview.filter; });
    var view = useSelector(function (state) { return state.shoppingReview.view; });
    var loadingState = useSelector(function (state) { return state.review.setReviewLoadingState; });
    var topFilerState = ((_b = view === null || view === void 0 ? void 0 : view.threads) === null || _b === void 0 ? void 0 : _b.length) > 1;
    var fetchReviewList = useCallback(function () {
        dispatch({
            type: S_REVIEW_LIST_REQUEST,
            payload: __assign({ item_id: item_id, idx_b_manager: idx_b_manager }, reviewFilter)
        });
    }, [userInfo, reviewFilter]);
    useEffect(function () {
        if (userInfoLoaded || viewLoaded) {
            fetchReviewList();
        }
    }, [reviewFilter, userInfoLoaded, viewLoaded]);
    return (React.createElement(Wrap, null,
        React.createElement(ScoreBox, { reviewInfo: reviewInfo, selectedMark: reviewFilter === null || reviewFilter === void 0 ? void 0 : reviewFilter.marks }),
        React.createElement(GalleryComponent, { item_id: item_id }),
        (view && ((_c = view === null || view === void 0 ? void 0 : view.threads) === null || _c === void 0 ? void 0 : _c.length) > 0)
            ? React.createElement(React.Fragment, null,
                topFilerState && React.createElement(TopFiler, null),
                (loadingState || !viewLoaded)
                    ? React.createElement(Loading2, null)
                    : React.createElement("div", null, view === null || view === void 0 ? void 0 : view.threads.map(function (v) { return (React.createElement(Item, { key: v.idx_threads, data: v })); })),
                view.lastPage > 1 && React.createElement(PageCompoenent, { reviewFilter: reviewFilter, reviewTotal: view === null || view === void 0 ? void 0 : view.total }))
            : React.createElement(Nolist, null, "\uB4F1\uB85D\uB41C \uC0C1\uD488\uD3C9\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.")));
};
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Nolist = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 300px;\n    font-size: 18px;\n    background: #fff;\n    color: #777;\n    border-bottom: 1px solid #ccc;\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 300px;\n    font-size: 18px;\n    background: #fff;\n    color: #777;\n    border-bottom: 1px solid #ccc;\n"])));
export default ShoppingBoard;
var templateObject_1, templateObject_2;
// const Style = styled.div`
//     margin: 40px 0 0;
//
//     /**
//      * 공용
//      * hoverPointer, text-bar
//      * */
//     .hoverPointer{cursor:pointer;}
//     .text-bar{
//         display:inline-block;
//         width:1px;
//         background:${color.colorD5};
//         margin:0 8px;
//         height:10px;
//     }
// `
// const Lits = styled.div`
//
// `



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/review/shopping/index.tsx
// module id = 252
// module chunks = 0